export enum SearchType {
  Online = 'online',
  Offline = 'offline',
  MlpaJobs = 'mlpaJobs'
}
